import { Heading, Text } from 'ui-kit/typography'
import { Picture } from 'ui-kit/picture'
import ImageMob from './image-mob.svg'
import ImageDesk from './image-desk.svg'
import classes from './WorkflowAutomationToolsInfrastructure.module.scss'

export const WorkflowAutomationToolsInfrastructure = () => {
  return (
    <div className={classes.wrapper}>
      <Heading as={'h2'} size={'xl'} center className={classes.title}>
        Your UX on top of our infrastructure
      </Heading>
      <Text size={'lg'} className={classes.subtitle}>
        We provide rich metadata, managed features, monitoring, and
        troubleshooting for your integrations. You focus on what is unique to
        your product: the user experience.
      </Text>
      <Picture
        className={classes.image}
        mobSvg={ImageMob.src}
        deskSvg={ImageDesk.src}
        alt='Your UX on top of our infrastructure'
        height={374}
        lazyLoad
      />
    </div>
  )
}
